
import React from "react";
import { Helmet } from "react-helmet-async";
import { Shield } from "lucide-react";
import { AdminStatus } from "@/components/role-manager/AdminStatus";
import { UserRolesTable } from "@/components/role-manager/UserRolesTable";
import { RoleSelectionCard } from "@/components/role-manager/RoleSelectionCard";
import { RoleBaseAssignments } from "@/components/role-manager/RoleBaseAssignments";
import { MenuItemsTable } from "@/components/role-manager/MenuItemsTable";
import { useRoleManager } from "@/hooks/role-manager/useRoleManager";

const RoleManager = () => {
  const {
    userRoles,
    loading,
    adminStatus,
    isAdmin,
    availableRoles,
    selectedRole,
    menuItems,
    loading: permissionsLoading,
    saving,
    sections,
    handleRoleChange,
    handleCheckboxChange,
    savePermissions
  } = useRoleManager();

  if (!isAdmin) {
    return null;
  }

  return (
    <div className="container mx-auto py-6 px-4">
      <Helmet>
        <title>Role Manager | CRM</title>
      </Helmet>
      
      <div className="mb-6">
        <h1 className="text-3xl font-bold flex items-center">
          <Shield className="mr-2 h-6 w-6" /> Role Manager
        </h1>
        <p className="text-muted-foreground mt-2">
          Configure roles, permissions, and base assignments
        </p>
      </div>
      
      <AdminStatus adminStatus={adminStatus} />
      
      <UserRolesTable userRoles={userRoles} loading={loading} />
      
      <RoleSelectionCard 
        availableRoles={availableRoles}
        selectedRole={selectedRole}
        onRoleChange={handleRoleChange}
        onSavePermissions={savePermissions}
        saving={saving}
      />
      
      <div className="mb-6">
        <RoleBaseAssignments selectedRole={selectedRole} />
      </div>
      
      <MenuItemsTable 
        loading={permissionsLoading}
        menuItems={menuItems}
        sections={sections}
        onCheckboxChange={handleCheckboxChange}
      />
    </div>
  );
};

export default RoleManager;
